module.exports = __webpack_public_path__ + "static/media/servicoAutomotivo.28252122.svg";